import { render, staticRenderFns } from "./NombreRenderer.vue?vue&type=template&id=68a63cc2"
import script from "./NombreRenderer.vue?vue&type=script&lang=js"
export * from "./NombreRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports